import { ITranslations } from '@model';
import { getPageFromRoute } from '@utils/routing';

import { ECountryLocale } from '../../../../../config';

import { PAGE_OFFSETS } from './constants';
import austrianTranslations from './staticTranslations/at.json';
import belgianTranslations from './staticTranslations/be.json';
import bulgarianTranslations from './staticTranslations/bg.json';
import swissTranslations from './staticTranslations/ch.json';
import czechTranslations from './staticTranslations/cz.json';
import germanTranslations from './staticTranslations/de.json';
import danishTranslations from './staticTranslations/dk.json';
import englishTranslations from './staticTranslations/en.json';
import spanishTranslations from './staticTranslations/es.json';
import finishTranslations from './staticTranslations/fi.json';
import frenchTranslations from './staticTranslations/fr.json';
import greekTranslations from './staticTranslations/gr.json';
import croatianTranslations from './staticTranslations/hr.json';
import hungarianTranslations from './staticTranslations/hu.json';
import italianTranslations from './staticTranslations/it.json';
import dutchTranslations from './staticTranslations/nl.json';
import polishTranslations from './staticTranslations/pl.json';
import portugueseTranslations from './staticTranslations/pt.json';
import romanianTranslations from './staticTranslations/ro.json';
import russianTranslations from './staticTranslations/ru.json';
import swedishTranslations from './staticTranslations/se.json';
import slovakianTranslations from './staticTranslations/sk.json';
import slovenianTranslations from './staticTranslations/sl.json';
import ukrainianTranslations from './staticTranslations/ua.json';

export const getMessages = (locale: ECountryLocale): ITranslations => {
  switch (locale) {
    case ECountryLocale.CZECHIA:
      return czechTranslations;
    case ECountryLocale.SLOVAKIA:
      return slovakianTranslations;
    case ECountryLocale.BRITAIN:
      return englishTranslations;
    case ECountryLocale.AUSTRIA:
      return austrianTranslations;
    case ECountryLocale.ROMANIA:
      return romanianTranslations;
    case ECountryLocale.SWITZERLAND:
      return swissTranslations;
    case ECountryLocale.SLOVENIA:
      return slovenianTranslations;
    case ECountryLocale.UKRAINE:
      return ukrainianTranslations;
    case ECountryLocale.BULGARIA:
      return bulgarianTranslations;
    case ECountryLocale.GREECE:
      return greekTranslations;
    case ECountryLocale.FINLAND:
      return finishTranslations;
    case ECountryLocale.DENMARK:
      return danishTranslations;
    case ECountryLocale.SWEDEN:
      return swedishTranslations;
    case ECountryLocale.CROATIA:
      return croatianTranslations;
    case ECountryLocale.BELGIUM:
      return belgianTranslations;
    case ECountryLocale.NETHERLANDS:
      return dutchTranslations;
    case ECountryLocale.ITALY:
      return italianTranslations;
    case ECountryLocale.FRANCE:
      return frenchTranslations;
    case ECountryLocale.PORTUGAL:
      return portugueseTranslations;
    case ECountryLocale.SPAIN:
      return spanishTranslations;
    case ECountryLocale.HUNGARY:
      return hungarianTranslations;
    case ECountryLocale.GERMANY:
      return germanTranslations;
    case ECountryLocale.POLAND:
      return polishTranslations;
    case ECountryLocale.RUSSIA:
      return russianTranslations;
    default:
      return englishTranslations;
  }
};

export const getPageOffSet = (pageRoute: string): number => {
  const page = getPageFromRoute(pageRoute);
  return page ? PAGE_OFFSETS[page] : 0;
};
